<div class="container">
  <main>
    <app-tabs>
      <app-id-browser-tab></app-id-browser-tab>
    </app-tabs>
  </main>
</div>